var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.valueIsDefined)?_c('incident-badge',{attrs:{"incidents":_vm.params.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }